import React from "react";
import { Button } from "@/components/ui/button";
import DesignInputsDrawer from "@/components/app/DesignInputsDrawer";
import { Compass, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader, Tile } from "./_shared";

export default function DesignInputsPanel({ project, onReload }) {
  return (
    <div data-testid={`panel-design-${project.id}`}>
      <PanelHeader icon={Compass} title="Design Inputs"
        subtitle="SOW · ToR · drawings · codes · design path"
        action={<DesignInputsDrawer project={project} onChanged={onReload}
                  trigger={<Button size="sm" variant="outline">Edit <ArrowRight size={11} className="ml-1" /></Button>} />} />
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        <Tile k="Design path" v={project.design_path || "—"} />
        <Tile k="Codes" v={(project.design_codes || []).length} />
        <Tile k="Drawings" v={(project.drawings || []).length} />
        <Tile k="SOW" v={project.sow_summary ? "Yes" : "—"} />
        <Tile k="ToR" v={project.tor_summary ? "Yes" : "—"} />
        <Tile k="Constraints" v={(project.design_constraints || "").length > 0 ? "Yes" : "—"} />
      </div>
    </div>
  );
}
